<template>
  <div>
    <v-sheet v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-sheet>
    <v-sheet v-else>
      <soft-drop-chart
        v-for="chart in charts"
        :key="chart.key"
        :title="chart.title"
        :type="chart.type"
        :series="chart.series"
        :selected-encounters="selectedEncounters"
      />
    </v-sheet>
  </div>
</template>

<script>
import softDropChart from './softDropChart.vue';
export default {
  name: 'fp-tab-content',
  components: {
    softDropChart
  },
  props: {
    date_start: {
      type: String,
      required: false
    },
    date_end: {
      type: String,
      required: false
    },
    input_method: {
      type: String,
      required: false
    },
    difficulty_level: {
      type: Number,
      required: false
    },
    is_player_critical_by_hp: {
      type: Boolean,
      required: false
    },
    is_player_critical_by_fp: {
      type: Boolean,
      required: false
    },
    immortality: {
      type: Boolean,
      required: false
    },
    new_game_plus: {
      type: Boolean,
      required: false
    },
    uses_infinite_ammo_in_inventory: {
      type: Boolean,
      required: false
    },
    selectedEncounters: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      loading: true,
      charts: [],
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/soft-drop/hp`, {
          params: {
            build_tag: this.$route.params.buildTag,
            date_start: this.date_start,
            date_end: this.date_end,
            input_method: this.input_method,
            difficulty_level: this.difficulty_level,
            is_player_critical_by_hp: this.is_player_critical_by_hp,
            is_player_critical_by_fp: this.is_player_critical_by_fp,
            immortality: this.immortality,
            new_game_plus: this.new_game_plus,
            uses_infinite_ammo_in_inventory: this.uses_infinite_ammo_in_inventory
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.charts = data
      }
      this.loading = false
    }
  }
}
</script>
